import constants from '../../../../ahm-constants';

const COMMON_QUESTIONS_URL = {
  car: constants.URLS.HELP.CAR_INSURANCE_COMMON_QUESTIONS,
  home: constants.URLS.HELP.HOME_INSURANCE_COMMON_QUESTIONS,
  travel: constants.URLS.HELP.TRAVEL_INSURANCE_COMMON_QUESTIONS,
};

// @ts-expect-error - Automatic, Please fix when editing this file
const getCommonQuestionsUrl = (insuranceType) => COMMON_QUESTIONS_URL?.[insuranceType];

export default getCommonQuestionsUrl;
